import { Drawer } from "@mantine/core";
import { HeldEmailDetailLoader } from "./HeldEmailDetailLoader";

interface Props {
  heldEmailId: string | null;
  opened: boolean;
  onClose: () => void;
}

export function HeldEmailDetailDrawer({ heldEmailId, opened, onClose }: Props) {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size="xl"
      title="Queued email"
    >
      <HeldEmailDetailLoader heldEmailId={opened ? heldEmailId : null} />
    </Drawer>
  );
}
